
<template>
    <component v-bind:is="layout"/>
</template>

<script>
  const defaultLayout = 'common-layout';

  import CommonLayout from "./views/layouts/CommonLayout";
  import LoginLayout from "./views/layouts/LoginLayout";

  export default {
    name: 'App',
    components: { CommonLayout, LoginLayout },
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout)
      },
    },
    mounted() {
      this.$store.commit('INIT_API_PARAMS')
      this.$store.dispatch('loadSettings')
    },
    watch: {
      '$store.state.token': function() {
        if (this.$store.getters.token !== ''){
          this.$store.dispatch('loadUser')
        }
      },
    }
  }
</script>

<style lang="sass">
  @import "assets/sass/main"
</style>
